/**
 * @file ChangeDistrict
 */

'use strict';

/**
 * @classname ChangeDistrict
 * @classdesc ChangeDistrict
 */
export default class ChangeDistrict {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log(`ChangeDistrict.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._getGroups = this._$e.data('get-groups') || null;
		this._getAffiliations = this._$e.data('get-affiliations') || null;
		this._getDormantOrganization = this._$e.data('get-dormant-organization') || null;
		this._$e.on('change', () => this.onChange());
		this._controller.on('getGroupsComplete', () => this.onGetGroupsComplete());
		this._controller.on('getGroupsAffiliationsComplete', () => this.onGetGroupsAffiliationsComplete());
		this._controller.on('blankGroupHasDistrict', () => this.onChange());
		this._inTable = this._$e.closest('.table').hasClass('registration') ? true : false;
		this._inModal = !!this._$e.closest('.modal').length;
		this._atSearch = this._$e.hasClass('search-item')? true : false;
		this._changed = false;
	}


	/**
	 * 'change' のコールバック
	 *
	 * @memberof ChangeDistrict
	 * @return {undefined}
	 */
	onChange() {
		console.log(`ChangeDistrict.onChange`);
		// getGroupsがない場合は無視
		if (!this._getGroups) return;
		if(this._$e.hasClass('ignore')) return;
		// 値が空に戻ったら、消す
		if (this.checkDispatchNecessity()) {
			this._controller.dispatchChangeCouncilOnChange()
		} else if (this._$e.val() === '') {
			console.log('blank value');
			const $tr = this._$e.closest('.tr');
			$tr.find('.group_id').html('<option value="">--</option>');
			$tr.find('.affiliation_id').html('<option value="">--</option>');
			$tr.find('.title_id').html('<option value="">--</option>');
			$('[data-search-item=group_id]').html('<option value="">--</option>');
			return;
		}
		this._getAffiliations ? this._controller.getGroupsAffiliations(this._$e.val(), this._getDormantOrganization) : this._controller.getGroups(this._$e.val(), this._getDormantOrganization)
		this._changed = true;
	}


	/**
	 * 
	 *
	 * @memberof ChangeDistrict
	 * @return {undefined}
	 */
	checkDispatchNecessity() {
		if (this._inModal) {
			return (this._$e.val() === '' && this._$e.closest('.modal').find('.council_id').val())
		} else if (this._inTable) {
			return (this._$e.val() === '' && this._$e.closest('.table').find('.council_id').val())
		} else {
			return (this._$e.val() === '' && this._$e.closest('form').find('.council_id').val())
		}
	}


	/**
	 * 団リスト取得完了コールバック
	 *
	 * @memberof ChangeDistrict
	 * @return {undefined}
	 */
	onGetGroupsComplete() {
		if (!this._changed) return;
		console.log(`ChangeDistrict.onGetGroupsComplete`);
		console.log(this._controller._groups);
		if (this._inTable) {
			this._$e.closest('.tr').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.tr').find('.affiliation_id').html('<option value="">--</option>');
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		} else if (this._inModal) {
			this._$e.closest('.modal').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.modal').find('.affiliation_id').html('<option value="">--</option>');
			this._$e.closest('.modal').find('.title_id').html('<option value="">--</option>');
		} else if (this._atSearch) {
			console.log('検索画面');
			$('.search-item[data-search-item=group_id]').html(this.createOptions(this._controller._groups));
		} else {
			$('.group_id').html(this.createOptions(this._controller._groups));
			$('.affiliation_id').html('<option value="">--</option>');
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * 団リスト・所属リスト取得完了コールバック
	 *
	 * @memberof ChangeDistrict
	 * @return {undefined}
	 */
	onGetGroupsAffiliationsComplete() {
		if (!this._changed) return;
		console.log(`ChangeDistrict.onGetGroupsAffiliationsComplete`);
		console.log(this._controller._groups);
		console.log(this._controller._affiliations);
		if (this._inTable) {
			this._$e.closest('.tr').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.tr').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		} else if (this._inModal) {
			this._$e.closest('.modal').find('.group_id').html(this.createOptions(this._controller._groups));
			this._$e.closest('.modal').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.modal').find('.title_id').html('<option value="">--</option>');
		} else {
			$('.group_id').html(this.createOptions(this._controller._groups));
			$('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * option生成
	 *
	 * @memberof ChangeDistrict
	 * @return {undefined}
	 */
	createOptions(items) {
		console.log(`ChangeDistrict.createOptions`);
		let options = '<option value="">▼選択</option>';
		items.forEach(item => options += `<option value='${item.id}'>${item.name}</option>`);
		return options
	}
}
